import moment from "moment";

export function applyDiscount({ discount, price, type }) {
  if (discount <= 0 || price <= 0) {
    return price;
  }

  let result;
  if (type === "percent") {
    // E.g. 20% off → multiply by (100 - 20) / 100
    result = (price * (100 - discount)) / 100;
  } else {
    // Fixed-price discount
    result = price - discount;
  }

  // Never return a negative number
  return result < 0 ? 0 : result;
}

export function getEndDate(productId) {
  let endDate;

  if (
    productId.includes("yearly") ||
    productId.includes("annually") ||
    productId.includes("enterprise")
  ) {
    endDate = moment().add(1, "year");
  } else if (productId.includes("monthly")) {
    endDate = moment().add(1, "month");
  } else {
    // default to one month if unspecified
    endDate = moment().add(1, "month");
  }

  return String(endDate.valueOf());
}
